import axios from "axios"
import { i18next } from "i18n"
import * as React from "react"
import { router } from "router"
import ReactDOM from "react-dom/client"
import { I18nextProvider } from "react-i18next"
import { RouterProvider } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

import { getDomain } from "utils/domain"
import { TicketProvider } from "contexts/ticket-context"
import { BaseContextProvider } from "contexts/use-base-context"

import "index.css"

axios.defaults.baseURL = getDomain()

const root = ReactDOM.createRoot(
  document.getElementById("guidebook-registration-root") as HTMLElement
)

const queryClient = new QueryClient()

root.render(
  // <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <QueryClientProvider client={queryClient}>
        <TicketProvider>
          <BaseContextProvider>
            <RouterProvider router={router} />
          </BaseContextProvider>
        </TicketProvider>
      </QueryClientProvider>
    </I18nextProvider>
  // </React.StrictMode>
)
